export const loaderSize = 50;
